const policies = `
query policies($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      source
      createdAt
      createdBy{
        associatedUser{
          name
        }
      }
      premium {
        formattedPrice
        appliedDiscounts{ code }
      }
      product{ name insurer{ name } productId{type plan version} }
      acceptedOffer {
        premium {
          formattedPrice
          appliedDiscounts{ code }
        }
        product{ name insurer{ name } productId{type plan version} }
      }
      issuerNumber
      holder{
        contacts{ id type value }
			}
      status
      startDate
      endDate
      issueDate
      referrer{
				name
				internalCode
			}
      holder{
        ... on individual { __typename id name }
        ... on company { __typename id name }
      }
    }
  }
}
`

const policy = `
	fragment Value on scalarValue {
		booleanValue
		dateValue
		stringValue
		numberValue
	}

	fragment TreeMapValues on scalarValue {
		...Value
		arrayValue {
			...Value
			objectValue {
				key
				value {
					...Value
				}
			}
		}
		objectValue {
			key
			value {
				...Value
			}
		}
	}

fragment BenefitNode on benefitGraph {
  name
  description
	isOptional
	isValueInput
	optionKey
	typeId
  formattedValue: value
  value: value2{
    ...TreeMapValues
  }
}

	fragment companiesFields on company {
		id
		__typename
		name
		registrationNumber
		natureOfBusiness
		source
		photoPath
		acceptsMarketing
		contacts {
			id
			type
			value
		}
		addresses {
			fields2 { type value }
			fields
			id
			type
		}
		identities {
			id
			type
			value
		}
		facts {
			id
			type
			value {
				...TreeMapValues
			}
		}
	}

	fragment objectsFields on object {
		__typename
		id
		name
		internalCode
		photoPath
		source
		typeId
		contacts {
			id
			type
			value
		}
		addresses {
fields2 { type value }
			type
			id
			fields
		}
		identities {
			id
			type
			value
		}
		facts {
			id
			type
			value {
				...TreeMapValues
			}
		}
	}

	fragment individualsFields on individual {
		__typename
		id
		name
		photoPath
		englishFirstName
		englishLastName
		chineseFirstName
		chineseLastName
		dateOfBirth
		gender
		occupation
		maritalStatus
		employmentStatus
		salutation
		preferredCommunicationChannel
		preferredLanguage
		countryOfResidency
		incomeRange {
			exclusiveMaximum
			exclusiveMinimum
			minimum
			maximum
		}
		acceptsMarketing
		source
		internalCode
		contacts {
			id
			type
			value
		}
		identities {
			id
			type
			value
		}
		addresses {
fields2 { type value }
			id
			fields
			type
		}
		facts {
			id
			type
			value {
				...TreeMapValues
			}
		}
	}

	query policy(
		$skip: Int
		$limit: Int
		$sort: sortInput
		$where: policyWhereInput
		$asOf: DateTimeOffset
	) {
		policies(skip: $skip, limit: $limit, sort: $sort, where: $where, asOf: $asOf) {
			totalCount
			list {
				startDate
				endDate
				status
				isIssued
				id
				source
				description
				exclusions {
					id
					codeName {
						code
						name
					}
					remark
				}
				issueDate
				cancellationReason
				createdAt
				createdBy {
					username
				}
				lastModifiedAt
				lastModifiedBy {
					username
				}
				issuerNumber
				isPremiumOverriden
				client {
					id
					name
				}
				benefitOptions {
					key
					name
					formattedValue
					benefitTypeId
					value {
						numberValue
						stringValue
						dateValue
						booleanValue
					}
				}
				benefitSummary {
					benefitGraphs {
						name
						...BenefitNode
						options {
							...BenefitNode
							children {
								...BenefitNode
							}
						}
						children {
							...BenefitNode
							children {
								...BenefitNode
								children {
									...BenefitNode
								}
							}
						}
					}
				}
				endorsements {
					id
				}
				values {
					key
					value {
						stringValue
						arrayValue {
              stringValue
              numberValue
              booleanValue
							objectValue {
								key
								value {
									stringValue
									numberValue
									booleanValue
									objectValue {
										key
										value {
											numberValue
											stringValue
											booleanValue
											dateValue
										}
									}
								}
							}
						}
					}
				}
				facts {
					id
					type
					value {
						stringValue
						numberValue
						booleanValue
						dateValue
						arrayValue {
							stringValue
						}
					}
				}
							clauses(sort: {fieldName: "order", type: "asc"} ) {
								id
								order
								htmlOverride
								template {
									id
									name
									graphQlQuery
									... on clauseHtml {
										html
									}
								}
								renderedHtmlResult {
									value
								}
								renderParameters {
									contentJsonString
									variablesJsonString
								}
							}
				attachments {
					path
					fileName
					createdAt
				}
				notes {
					id
					title
					content
					createdAt
					createdBy {
						username
						associatedUser {
							name
						}
					}
				}
				otherHolders {
					name
				}
				insured {
					name
				}
				holder {
					... on individual {
						...individualsFields
					}
					... on company {
						...companiesFields
					}
				}
				contractHolder {
					... on individual {
						...individualsFields
					}
					... on company {
						...companiesFields
					}
				}
				otherContractHolders {
					... on individual {
						...individualsFields
					}
					... on company {
						...companiesFields
					}
				}

				contractInsured {
					... on individual {
						...individualsFields
					}
					... on company {
						...companiesFields
					}
					... on object {
						...objectsFields
					}
				}

				offers {
					id
					product {
						name
						productId {
							plan
							type
							version
						}
					}
					premium {
						amount
						currencyCode
					}
				}
				referrer {
					name
					internalCode
				}
				paymentInfos {
					id
					method
					name
					amount
					comment
					currencyCode
					frequency
				}
				product {
					productId {
						plan
						type
						version
					}
					name
					insurer {
						id
						name
						logoUrls {
							typeA
						}
					}
					benefitGraph {
						...BenefitNode
						options {
							...BenefitNode
						}
						children {
							...BenefitNode
							options {
								...BenefitNode
							}
							children {
								...BenefitNode
								options {
									...BenefitNode
								}
							}
						}
						options {
							...BenefitNode
						}
					}
					benefits(typeIds: [], includeOptionals: true) {
						typeId
						value
					}
				}
				premium {
					amount
					currencyCode
					formattedPrice
					formattedOriginalPrice
					originalPrice
					appliedTaxes {
						code
						name
						ratio
						flat
						formattedFlat
						order
						formattedOriginalPrice
						originalPrice
					}
					appliedDiscounts {
						code
						name
						ratio
						flat
						formattedFlat
						order
						formattedOriginalPrice
						originalPrice
						id
					}
					discountCodes
					loadings {
						id
						order
						codeName {
							code
							name
						}
						ratio
						flat
						formattedOriginalPrice
					}
					paymentFrequency
				}
				acceptedOffer {
					benefitOptions {
						name
						formattedValue
					}
					product {
						productId {
							plan
							type
							version
						}
						name
						insurer {
							id
							name
							logoUrls {
								typeA
							}
						}
						benefits(typeIds: [], includeOptionals: true) {
							typeId
							value
						}
					}
					exclusions {
						id
						codeName {
							code
							name
						}
						remark
					}
					benefitOptions {
						benefitTypeId
						value {
							...TreeMapValues
						}
					}
					premium {
						amount
						currencyCode
						formattedPrice
						formattedOriginalPrice
						originalPrice
						appliedTaxes {
							code
							name
							ratio
							flat
							formattedFlat
							order
							formattedOriginalPrice
							originalPrice
						}
						appliedDiscounts {
							code
							ratio
							flat
							formattedFlat
							order
							formattedOriginalPrice
							originalPrice
						}
						loadings {
							id
							codeName {
								code
								name
							}
							ratio
							flat
						}
					}
				}
				beneficiaryEligibilities {
					id
					ratio
					notes
					entity {
						id
						name
						relationships {
							type
						}
					}
				}
			}
		}
	}
`

const benefitSummary = `
fragment Node on benefitGraph{
  name
  description
  isOptional
  formattedValue: value
  value: value2{
    stringValue
    numberValue
  }
}

fragment BenefitGraph on benefitGraph{
  ...Node
  children{
    ...Node
    children{
      ...Node
      children{
        ...Node
        children{
          ...Node
        }
      }
    }
  }
}

query policy($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      acceptedOffer{
        benefitSummary{
          benefitGraphs{
            ...BenefitGraph
          }
        }
      }
    }
  }
}
`

const cancelPolicy = `
mutation cancelPolicy($policyId: String! $reason: String!){
  cancelPolicy(policyId: $policyId reason: $reason){
    status
    errors
  }
}
`

const initializeTransaction = `
mutation initializeTransaction($input: initializeTransactionInput!){
  initializeTransaction(input:$input){
    value{
      token
			url
			transactionId
    }
    errors
  }
}
`

const sendNotification = `
mutation sendNotification($input: sendNotificationInput!){
  sendNotification(input: $input){
    status
    errors
  }
}
`

const policyLogs = `
query policies($where: policyWhereInput $skip: Int $limit: Int $sort: sortInput){
  policies(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      events{
        timestamp
        by{
          username
        }
        type
      }
    }
  }
}
`

const policyTransactions = `
query policies($where: policyWhereInput $skip: Int $limit: Int $sort: sortInput){
  policies(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      transactions{
        id
        formattedTransaction
        currencyCode
        dateTime
        amount
        status
				method
				transactionNumber
      }
    }
  }
}
`

const policyClaims = `
query policyClaims($limit: Int $skip: Int $sort: sortInput $where: policyWhereInput) {
  policies(limit: $limit, skip: $skip, where: $where, sort: $sort) {
    list {
      claims{
        id
        claimant {
          id name
        }
        policy {
          id status issuerNumber
        }
        createdAt
        id
        issuerNumber
        status
      }
    }
    totalCount
  }
}
`

const removeCommissionRuleFromPolicy = `
mutation removeCommission($policyId:String! $id:String!){
  removeCommission(policyId:$policyId id:$id){
    status
    errors
  }
}
`

const addCommissionRuleToPolicy = `
mutation addCommission($policyId:String! $input:commissionInput!){
  addCommission(policyId:$policyId input:$input){
    status
    errors
  }
}
`

const updatePolicyCommissionRule = `mutation updateCommission($policyId:String! $id:String! $input:commissionInput!){
  updateCommission(policyId:$policyId id:$id input:$input){
    status
    errors
  }
}
`

const commissionSplitAndSummary = `
query commissionSplitAndSummary($where:policyWhereInput) {
  policies(where:$where){
    list {
      commissionSplitRules {
        id
        entity {
          __typename
          id
          name
        }
        baseCommissionRatio {
          ratio
        }
        currencyCode
        amount
				ratio
				remark
        type
        entity {
          name
        }
        jsonRule
      }
      commissionSummary {
        currencyCode
        amount
        ratio
        entity{
          __typename
          id
          name
        }
      }
    }
  }
}
`

const addPaymentInfo = `
mutation addPaymentInfo($policyId: String! $input: addPaymentInfoInput!){
  addPaymentInfo(policyId: $policyId, input: $input){
            status
      }
}
`

const updatePaymentInfo = `
mutation updatePaymentInfo($id: String! $paymentId: String! $updateIssuedPaymentInput: paymentInfosToUpdate!){
  updatePaymentInfo(id: $id, paymentId: $paymentId, updateIssuedPaymentInput: $updateIssuedPaymentInput){
            status
      }
}
`

const removePaymentInfo = `
mutation removePaymentInfo($id: String! $paymentId: String!){
  removePaymentInfo(id: $id, paymentId: $paymentId){
            status
      }
}
`

const addTransaction = `
mutation addTransaction($input: createTransactionInput!){
  createTransaction(input: $input){
    status
    errors
  }
}`

const updateTransaction = `
mutation updateTransaction($transactionId: String! $input: updateTransactionInput!){
  updateTransaction(transactionId: $transactionId input: $input){
    status
    errors
  }
}`

const deletePolicy = `
mutation deletePolicy($id: String!){
  deletePolicy(id: $id){
    status
    errors
  }
}`

const updatePolicy = `
mutation updatePolicy($policyId: String! $updatedPolicy: updatePolicyInput!){
  updatePolicy(policyId: $policyId updatedPolicy: $updatedPolicy){
    status
  }
}
`

const addEndorsement = `mutation addEndorsement($policyId: String!) {
  addEndorsement(policyId: $policyId){
    createdStatus {
      id
    }
    errors
    status
  }
}`

const validatePolicy = `
query validatePolicy($policyId: String!){
  validatePolicy_2(policyId: $policyId){
    status
    errors
    errors_2{
      code
      message
    }
  }
}`

const issuePolicy = `
	mutation issuePolicy(
		$policyId: String! 
		$issuerNumber: String 
		$ignoreIssuanceValidation: Boolean
		$ignoreCollateralValidation: Boolean
		$isManual: Boolean
	){
		issuePolicy(
			policyId: $policyId 
			issuerNumber: $issuerNumber 
			ignoreIssuanceValidation: $ignoreIssuanceValidation
			ignoreCollateralValidation: $ignoreCollateralValidation
			isManual: $isManual
		){
			status
			errors
			policyStatus{
				id
				status
			}
		}
	}
`

const templates = `
  query templates(
    $where: templateWhereInput
  ) {
    templates(
    where: $where
    ) {
      list {
        ... on emailMjmlTemplate {
          subject
        }
      }
    }
  }
`

// Wonder payments for a policy, from the Payments service (V2).
const policyPayments = `
query policyPayments($where: PaymentsWhereInput){
  payments(where: $where){
    totalCount
    items{
      id
      paymentProvider
      paymentMethod
      status
      invoiceNumber
      effectiveDate
      money{
        paymentAmount
        paymentCurrencyDesc
      }
    }
  }
}
`

const query = {
	policies,
	policyPayments,
	policy,
	policyLogs,
	policyTransactions,
	commissionSplitAndSummary,
	policyClaims,
	benefitSummary,
	validatePolicy,
	templates
}

const mutation = {
	addEndorsement,
	cancelPolicy,
	sendNotification,
	initializeTransaction,
	addCommissionRuleToPolicy,
	updatePolicyCommissionRule,
	removeCommissionRuleFromPolicy,
	addPaymentInfo,
	updatePaymentInfo,
	removePaymentInfo,
	addTransaction,
	updateTransaction,
	deletePolicy,
	updatePolicy,
	issuePolicy
}

export { query, mutation }
